import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function VehoOutline(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    clipPath: "url(#prefix__clip0_145_30)"
  }, React.createElement(Path, {
    fillRule: "evenodd",
    d: "M2.035 3.767C2.538 3.252 3.22 3 3.981 3h12.113c.999 0 1.785.562 2.25 1.102l4.938 6.564.003.002a2.703 2.703 0 01-.003 3.666l-.023.026-5.782 5.606c-.022.02-.048.047-.079.077-.15.148-.395.388-.67.563-.393.25-.855.394-1.436.394H9.584l.63-4.195.01-.046c.019-.072.037-.151.056-.235.07-.3.153-.659.275-.946.203-.478.528-.853 1.046-1.147l.026-.015 3.877-1.902-5.223-2.07c-.312-.115-.63-.1-.84-.016-.179.073-.238.167-.25.298l-.003.02L7.733 21H2.778a2.96 2.96 0 01-1.967-.764c-.51-.464-.908-1.186-.79-2.032l1.228-12.64c.07-.646.3-1.298.786-1.797zM3.237 5.78L2.005 18.456l-.003.022c-.005.03-.005.134.155.28.162.147.4.243.62.243h3.22l1.206-8.498c.107-.972.741-1.625 1.487-1.927.72-.292 1.563-.278 2.3-.001l.01.003 5.56 2.204c.672.252 1.23.887 1.23 1.719 0 .813-.534 1.44-1.188 1.703l-4.035 1.98a.514.514 0 00-.121.091.285.285 0 00-.05.087c-.027.06-.055.149-.093.304l-.057.24-.004.017c-.02.082-.04.174-.065.272L11.907 19h3.385c.221 0 .307-.046.362-.081.042-.027.093-.066.167-.135a6.046 6.046 0 00.144-.138l.132-.128 5.717-5.542c.254-.3.248-.676-.019-.973l-.004-.005-4.953-6.58-.005-.007c-.23-.269-.511-.411-.739-.411H3.981c-.307 0-.443.09-.514.164-.089.09-.193.274-.23.615z",
    clipRule: "evenodd"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_145_30"
  }, React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}

export default VehoOutline;